import React, { FC } from 'react'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'
import { theme } from '../../theme/index'
import { ModalProvider } from 'styled-react-modal'
import BackgroundModal from '../../ui/BackgroundModal'

const ThemeProvider: FC = ({ children }) => (
  <>
    <StyledThemeProvider theme={theme}>
      <ModalProvider backgroundComponent={BackgroundModal}>
        <>{children}</>
      </ModalProvider>
    </StyledThemeProvider>
  </>
)

export default ThemeProvider
